// Tab functionality for Blocks.
$j(function() {
	if ($j('.rm-tab-wrapper__nav').length) {
		var hash = '';

		if (window.location.hash) {
			hash = window.location.hash.substring(1);
		}

		set_active_tab(hash);
	
		// Tab Navigation.
		$j('.rm-tab-wrapper__nav a').on('click', function(event) {
			event.preventDefault();

			// Clear any existing active classes.
			$j(this).closest('.rm-tab-wrapper__nav').find('a').removeClass('active');
			$j(this).closest('.rm-tab-wrapper').find('div[data-tab-content]').hide().removeClass('active');

			// Make Nav Item Active.
			$j(this).addClass('active');

			// Match Tab Slug with Content Slug.
			var tab = $j(this).data('tab-slug');
			var tab_hash = '#' + $j(this).data('tab-hash');
			var new_active_tab = $j(this).closest('.rm-tab-wrapper').find('div[data-tab-content="' + tab + '"]');

			if (history.pushState) {
				history.pushState(null, null, tab_hash);
			}

			new_active_tab.show().addClass('active');

			$j(this).blur();
		});
	}
});

function set_active_tab(hash) {
	if (hash) {
		// Clear actives.
		$j('.rm-tab-wrapper__nav a').removeClass('active');
		$j('.rm-tab-content').removeClass('active');

		// Set actives by URL anchor
		$j('.rm-tab-wrapper__nav a[data-tab-hash="' + hash + '"]').addClass('active');
		$j('.rm-tab-content[data-tab-content-hash="' + hash + '"]').addClass('active');
	}
}
